export default "__VITE_ASSET__de681bb6__"